@if (!loading && alarms.length === 0) {
<p class="text-muted">Aucune alarme récente</p>
}

<ul class="alarms-list">
  @for (a of alarms; track a) {
  <li class="alarm-item">
    <div class="alarm-icon"><em class="fal fa-bolt"></em></div>
    <div class="alarm-content">
      <span class="alarm-time">{{ a.time | amLocale : 'fr' | amTimeAgo }} · {{ a.time | date : 'dd.MM.yyyy' }}</span>
      <p class="alarm-message">{{ a.message }}</p>
    </div>
  </li>
  }
</ul>

@if (loading) {
<div class="sk-loading">
  <div class="spiner-example">
    <div class="sk-spinner sk-spinner-wave">
      <div class="sk-rect1"></div>
      <div class="sk-rect2"></div>
      <div class="sk-rect3"></div>
      <div class="sk-rect4"></div>
      <div class="sk-rect5"></div>
    </div>
  </div>
</div>
}
